import React, { memo } from "react";
import {
  BaseEdge,
  EdgeLabelRenderer,
  Position,
  getBezierPath,
} from "reactflow";
import EdgeDeleteButton from "./EdgeDeleteButton";

interface FlowGlobalEdgeProps {
  id: string;
  sourceX: number;
  sourceY: number;
  sourcePosition?: Position;
  targetX: number;
  targetY: number;
  targetPosition?: Position;
  selected?: boolean;
}

function FlowGlobalEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  selected,
}: FlowGlobalEdgeProps) {
  const adjustedTargetY = targetY - 5;

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY: adjustedTargetY,
    targetPosition,
  });

  const gradientId = 'gradientId';
  const selectedGradientId = `selected-gradient-${id}`;

  return (
    <>
      <defs>
        <linearGradient id={gradientId} x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='white' />
          <stop offset='100%' stopColor='blue' />
        </linearGradient>
        {selected && (
          <linearGradient
            id={selectedGradientId}
            x1='0%'
            y1='0%'
            x2='100%'
            y2='0%'
          >
            <stop offset='0%' stopColor='#3650DE' />
            <stop offset='100%' stopColor='#3650DE' />
          </linearGradient>
        )}
      </defs>
      <BaseEdge
        path={edgePath}
        interactionWidth={20}
        style={{
          stroke: selected
            ? `url(#${selectedGradientId})`
            : `url(#${gradientId})`,
          strokeDasharray: 'none',
          strokeWidth: selected ? 9 : 7,
        }}
      />
      {selected && (
        <EdgeLabelRenderer>
          <EdgeDeleteButton id={id} labelX={labelX} labelY={labelY} />
        </EdgeLabelRenderer>
      )}
    </>
  );
}

export default memo(FlowGlobalEdge);
